// module_configs/cosmetics.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faBoxes, faCog, faWandMagicSparkles, faUsersCog
} from '@fortawesome/free-solid-svg-icons';

// Import Cosmetics components
import DashboardHome from '.././module_cosmetics/cosmetics_homedash';

import DashboardHomeUser from '.././module_cosmetics/cosmetics_Userhomedash';

import AddCustomer from '.././module_mechanics/mechanics_customer';

import CustomerList from '.././module_mechanics/mechanics_customer_list';

import AddSupplier from '.././module_mechanics/mechanics_Supplier';

import SupplierList from '.././module_mechanics/mechanics_SuppliersList';

import AddEmployee from '.././module_mechanics/mechanics_employees';

import MecEmployeeList from '.././module_mechanics/mechanic_employeelist';

import CosmeticsProducts from '.././module_cosmetics/cosmetics_products';

import CosmeticsProductsList from '.././module_cosmetics/cosmetics_productslist';

import CosmeticsPurchases from '.././module_cosmetics/cosmetics_Purchases';

import CosmeticsPurchaseList from '.././module_cosmetics/cosmetics_PurchaseList';

import CosmeticsReturn from '.././module_cosmetics/cosmetics_Return';

import CosmeticsReturnList from '.././module_cosmetics/cosmetics_Returnlist';

import CosmeticsSell from '.././module_cosmetics/cosmetics_Sell';

import CosmeticsSalesList from '.././module_cosmetics/cosmetics_SellList';

import CosmeticsSalesInvoicesList from '.././module_cosmetics/cosmetics_SellInvoiceList';

import MechanicsBarcode from '.././module_mechanics/mechanics_BarcodeGenerator';

import RootUsers from '.././module_roots/RootUsers';

import MessageSystem from '.././module_roots/MessageSystem';

import AddTransactionForm from '.././module_cosmetics/cosmetics_addtransactions';

import CosmeticsTransactions from '.././module_cosmetics/cosmetics_transactions';

import CosmeticsSupplierPurchases from '.././module_cosmetics/cosmetics_PurchasesSupplierwise';

import CosmeticsInvoicePurchaseList from '.././module_cosmetics/cosmetics_InvoicePurchaseList';

export const cosmeticsConfig = {
  moduleId: 'cosmetics',
  moduleName: 'Cosmetics & Beauty',
  icon: faWandMagicSparkles,
  description: 'Cosmetics & Beauty Shop Management System',
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'admin_cosmetics': { level: 1, label: 'Admin', color: '#ec4899' },
    'manager_cosmetics': { level: 2, label: 'Manager', color: '#f43f5e' },
    'user_cosmetics': { level: 3, label: 'User', color: '#be185d' },
    'viewer_cosmetics': { level: 4, label: 'Viewer', color: '#db2777' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 2 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 3 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 4 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: AddCustomer,
          icon: faUserPlus,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: CustomerList,
          icon: faUsersLine,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: AddSupplier,
          icon: faUserTie,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: SupplierList,
          icon: faBuildingUser,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: AddEmployee,
          icon: faUserPlus,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: MecEmployeeList,
          icon: faIdCard,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'stock',
      label: 'Stock',
      icon: faCubes,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'inventory',
      position: 4,
      submenus: [
        {
          id: 'addstock',
          label: 'Add Stock',
          component: CosmeticsProducts,
          icon: faCube,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'stocklist',
          label: 'Stock List',
          component: CosmeticsProductsList,
          icon: faListAlt,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase',
      icon: faTruckFast,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'inventory',
      position: 5,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: CosmeticsPurchases,
          icon: faCartPlus,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: CosmeticsPurchaseList,
          icon: faFileInvoice,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'purchasessupplierwise',
          label: 'Supplier-wise',
          component: CosmeticsSupplierPurchases,
          icon: faBuilding,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'purchasesinvoicewise',
          label: 'Bill-wise',
          component: CosmeticsInvoicePurchaseList,
          icon: faReceipt,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'returns',
      label: 'Purchase Return',
      icon: faArrowRotateLeft,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'inventory',
      position: 6,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Return',
          component: CosmeticsReturn,
          icon: faRotateLeft,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'returnlist',
          label: 'Return List',
          component: CosmeticsReturnList,
          icon: faListCheck,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'sales',
      position: 7,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: CosmeticsSell,
          icon: faCartPlus,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: CosmeticsSalesList,
          icon: faClipboardList,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'salesproductswise',
          label: 'Product-wise',
          component: CosmeticsSalesInvoicesList,
          icon: faClipboardList,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'salesreturn',
      label: 'Sales Return',
      icon: faArrowRotateLeft,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'sales',
      position: 8,
      submenus: [
        {
          id: 'addsalesreturn',
          label: 'New Return',
          component: CosmeticsReturn,
          icon: faRotateLeft,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        },
        {
          id: 'salesreturnlist',
          label: 'Return List',
          component: CosmeticsReturnList,
          icon: faListCheck,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'transactions',
      label: 'Transactions',
      icon: faArrowRightArrowLeft,
      roles: ['admin_cosmetics', 'manager_cosmetics'],
      groupId: 'sales',
      position: 9,
      submenus: [
        {
          id: 'addtransaction',
          label: 'Add Transaction',
          component: AddTransactionForm,
          icon: faPlus,
          roles: ['admin_cosmetics', 'manager_cosmetics']
        },
        {
          id: 'transactionsmanager',
          label: 'Transactions',
          component: CosmeticsTransactions,
          icon: faMoneyBillWave,
          roles: ['admin_cosmetics', 'manager_cosmetics']
        }
      ]
    },
    {
      id: 'barcode',
      label: 'Barcodes',
      icon: faQrcode,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'inventory',
      position: 10,
      submenus: [
        {
          id: 'barcodeprinting',
          label: 'Barcode Printing',
          component: MechanicsBarcode,
          icon: faPrint,
          roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics']
        }
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_cosmetics'],
      groupId: 'system',
      position: 11,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics'],
      groupId: 'system',
      position: 12,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '$1,245' },
    { id: 'products', label: 'Products', icon: 'faBoxes', value: 156 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 89 },
    { id: 'pending', label: 'Pending Orders', icon: 'faClock', value: 7 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + C', description: 'Add Customer' },
    { key: 'Alt + L', description: 'Customer List' },
    { key: 'Alt + P', description: 'Stock List' },
    { key: 'Alt + S', description: 'New Sale' },
    { key: 'Alt + U', description: 'New Purchase' },
    { key: 'Alt + R', description: 'New Return' },
    { key: 'Alt + T', description: 'Add Transaction' },
    { key: 'Alt + E', description: 'Add Employee' },
    { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};